import {PaginateOptions} from "../../../agent";
import {SpecialGroup} from "../../dashboard";
import {OldBaseDataProvider} from "./OldBaseDataProvider";

export class SpecialGroupDataProvider
    extends OldBaseDataProvider<SpecialGroup, PaginateOptions> {
    constructor() {
        super(`/specialGroup`);
    }
}